import { Plugin } from "prosemirror-state";
import { Slice, Fragment, Schema, Node } from "prosemirror-model";

export const pastingHandler = (
  fragment: Fragment,
  getAttrs,
  schema: Schema
) => {
  const nodes: Node[] = [];

  fragment.forEach((child: Node) => {
    if (child.type.name === "paragraph" && !child.textContent) {
      let breaks = 0;
      const newChildren = [];
      for (let i = 0; i < child.childCount; i++) {
        const childAtIndex = child.child(i);
        if (childAtIndex.type.name === "mention") {
          nodes.push(
            child.copy(pastingHandler(child.content, getAttrs, schema))
          );
          return;
        }
        if (childAtIndex.type.name === "hardBreak") {
          breaks++;
        }
      }
      for (let i = 0; i < breaks - 1; i++) {
        const breakNode = Node.fromJSON(schema, { type: "hardBreak" });
        newChildren.push(breakNode);
      }
      if (breaks > 1) {
        const textNode = schema.text("\u2028");
        newChildren.push(textNode);
      }

      const childrenFragment = Fragment.fromArray(newChildren);

      const paragraphNode = Node.fromJSON(schema, {
        type: "paragraph",
        content: childrenFragment.toJSON(),
      });

      nodes.push(paragraphNode);
    } else {
      nodes.push(child.copy(pastingHandler(child.content, getAttrs, schema)));
    }
  });

  return Fragment.fromArray(nodes);
};

export function nodePasteRuleParagraph(getAttrs, schema: Schema) {
  return new Plugin({
    props: {
      transformPasted: (slice) =>
        new Slice(
          pastingHandler(slice.content, getAttrs, schema),
          slice.openStart,
          slice.openEnd
        ),
    },
  });
}
